const data = {
  counterText: 'ਸੀਮਤ ਸਲਾਟ ਉਪਲਬਧ ਹਨ',
  loading: 'ਲੋਡ ਹੋ ਰਿਹਾ ਹੈ',
  next: 'ਅਗਲਾ',
  previous: 'ਪਿਛਲਾ',
  smCounterText: 'ਸੀਮਤ ਸਲਾਟ ਬਚੇ ਹਨ',
};

export default data;
